<template>
  <div class="gf_plan-item">
    <div
      class="gf_plan-item__section"
      :class="{ is_recommended: isRecommended, is_current_plan: isCurrentPlan }"
    >
      <div v-if="isCurrentPlan" class="gf_plan-item__section--current">
        <p class="gf_plan-item__section--current--txt">{{ $t("dataNewPlan.currentYourPlan") }}</p>
        <i class="icon icon-new-arrow-down"></i>
      </div>
      <div v-if="isRecommended" class="gf_plan-item__section--recommend">
        {{ planInAdvancedOptimize ? $t("dataNewPlan.recommended") : $t("dataNewPlan.mostPopular") }} 
      </div>
      <div class="gf_plan-item__section--name" v-if="newPlanCurrently">
        <span>{{ $t(title) }} {{ oldPlan && advancedProfessional ? $t(oldPlan.title) : '' }}</span>
        <div class="gf_pricing-tooltips" v-if="advancedProfessional">
          <i class="icon icon-help" v-popover:tooltipPricing.rightPricing="oldPlan ? oldPlan.tooltip.content : ''"></i>
        </div>
      </div>
      <div class="gf_plan-item__section--name" v-else>
        <span :class="{'starter-disable': planInStarter}">{{ $t(title) }}</span>
      </div>
      <div class="gf_plan-item__section--desc" :class="{'starter-disable': planInStarter}" v-if="newPlanCurrently" v-html="oldPlan && advancedProfessional ? $t(oldPlan.description) : $t(description)">
      </div>
      <div class="gf_plan-item__section--desc" :class="{'starter-disable': planInStarter}" v-else v-html="$t(description)"></div>
      <Portal to="tooltips">
        <transition name="fade">
          <Tooltip name="tooltipPricing" :delay="0" :pointer="true" :width="'291px'" :maxWidth="'291px'"/>
        </transition>
      </Portal>
    </div>
  </div>
</template>

<script>
import promotion from "@/modules/Pricing/mixins/promotion";
import plan from "@/modules/Pricing/mixins/plan";
import planItem from "@/modules/Pricing/mixins/planItem";


export default {
  name: "RowHeaderItem",
  mixins: [promotion(), plan(), planItem()],
};
</script>
